import { cva, } from 'class-variance-authority';

export { default as Card, } from './Card.vue';
export { default as CardHeader, } from './CardHeader.vue';
export { default as CardTitle, } from './CardTitle.vue';
export { default as CardDescription, } from './CardDescription.vue';
export { default as CardContent, } from './CardContent.vue';
export { default as CardFooter, } from './CardFooter.vue';

export const cardVariants = cva(
  'w-70 rounded shadow-sm hover:shadow-md',
  {
    variants: {
      intent: {
        infoCard: 'border bg-white space-y-4 p-6 border-gray-100 rounded-lg',
        courseCards: 'border bg-white border-gray-100 relative h-[330px] w-[280px] rounded-xl shadow-none hover:shadow-lg',
        orderCards: 'border bg-white border-gray-150 relative h-auto w-auto rounded-xl shadow-none hover:shadow-lg',
        scrollCards: 'border bg-white border-gray-100 relative w-52 md:h-[330px] md:w-[280px] rounded-xl shadow-none hover:shadow-lg flex-shrink-0 w-52 pb-4 flex flex-col cursor-pointer',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  }
);
